import { ChangeEventHandler } from "react";
import { ArrayElement } from "../../../../types/util";
import { calculatorActions } from "../../../redux/co2calculatorSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { usePrismaTranslations } from "../../../util/calculator";
import { TSelectCurrentQuestion } from "../../../util/prismaHelper";

export type SelectAnswerProps = {
  answer: ArrayElement<TSelectCurrentQuestion["QAnswer"]>;
  qId: string;
};

function SelectAnswer({ answer, qId }: SelectAnswerProps) {
  const a = useAppSelector((state) => state.calculator.answers[qId].value);
  const currentCategory = useAppSelector(
    (state) => state.calculator.currentQuestion!.category
  );
  const dispatch = useAppDispatch();
  const tPrisma = usePrismaTranslations(answer.QAnswerLabelTranslation);
  const dataList = (answer.data as { key: string; value: number }[]) || [];

  const onChange: ChangeEventHandler<HTMLSelectElement> = (event) => {
    const key: string = event.target.value;
    const d = dataList.find((o) => o.key === key);
    dispatch(
      calculatorActions.asyncUpdateAnswer({
        qId,
        qaId: answer.id,
        value: {
          value: d ? { key: d.key, value: d.value } : key,
          _meta: {
            [answer.id]: { ...(d ? d : { key }), category: currentCategory },
          },
        },
      })
    );
  };

  return (
    <div>
      <select
        value={
          (a == null || typeof a === "string" || typeof a === "number"
            ? a
            : a.key) ?? undefined
        }
        onChange={onChange}
      >
        <option></option>
        {dataList.map((o) => (
          <option key={o.key} value={o.key}>
            {tPrisma.label(o) ?? o.key}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectAnswer;
